import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Auth/Login";
import Register from "./pages/Auth/Register";
import Dashboard from "./pages/Admin/Dashboard";
import Verify from "./pages/Auth/Verify";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginNotice from "./pages/Auth/LoginNotice";
import VerifyLogin from "./pages/Auth/VerifyLogin";
import VerifyRegister from "./pages/Auth/VerifyRegister";
import VerifySuccess from "./pages/Auth/VerifySuccess";
import VerifyCancel from "./pages/Auth/VerifyCancel";
import RevolutPaymentRedirect from "./pages/Auth/dopay";
import VerifyPayment from "./pages/Auth/VerifyPayment";
import VerifyPaymentSuccess from "./pages/Auth/VerifyPaymentSuccess";
import VerifyIDNow from "./pages/Auth/VerifyIDNow";
import AccessDenied from "./pages/Auth/AccessDenied";
import VerifyStartVerification from "./pages/Auth/VerifyStartVerification";


export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/start" element={<LoginNotice />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verifylogin" element={<VerifyLogin />} />
        <Route path="/verifyregister" element={<VerifyRegister />} />
        <Route path="/verifysuccess" element={<VerifySuccess />} />
        <Route path="/Verifypayment" element={<VerifyPayment />} />
        <Route path="/verifycancel" element={<VerifyCancel />} />
        <Route path="/pay/:id" element={<RevolutPaymentRedirect />} />
        <Route path="/paymentverified/:id" element={<VerifyPaymentSuccess />} />
          <Route path="/VerifyStartVerification/:id" element={<VerifyStartVerification />} />
        <Route path="/verifyID/:id" element={<VerifyIDNow />} />


        <Route path="/accessdenied" element={<AccessDenied />} />

        <Route path="/register" element={<Register />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/admin/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}
